<!-- 个人中心页 -->
<template>
    <div class="home">
        <c-header></c-header>
        <!-- 检索组件 -->
        <c-search :isHomeList="IsHomeList" :loadDict="LoadDict" @emitSearch="emitSearch" @emitHighSearch="emitHighSearch"></c-search>
        <div class="content">
            <!-- 导航组件 -->
            <v-nav :loadDict="LoadDict" :echoData="EchoData" @emitNav="emitNav"></v-nav>
            <!-- 搜索记录组件 -->
            <Tag v-for="(item, index) in RecordValue" :key="index" closable @on-close="handleClose(item)">
                {{ item.describe}}</Tag>
            <!-- 搜索列表组件 -->
            <c-list :isHomeList="IsHomeList" :listTitle="ListTitle" :listData="ListData" :spinShow="SpinShow"
                :routerName="RouterName" @emitToDetails="emitToDetails"></c-list>
            <!-- 法规导航组件 -->
            <v-category :loadDict="LoadDict"></v-category>
        </div>
        <c-footer></c-footer>
    </div>
</template>

<script>
    import CHeader from '@/components/CHeader'
    import CFooter from '@/components/CFooter'
    import CSearch from '@/components/CSearch'
    import CList from '@/components/CList'
    import VNav from '@/views/home/VNav'
    import VCategory from '@/views/home/VCategory'
    import { reqCause } from "@/api/index";
    export default {
        name: 'Home',
        components: {
            CHeader,
            CFooter,
            CSearch,
            CList,
            VNav,
            VCategory
        },
        props: {

        },
        data() {
            return {
                LoadDict: false,
                // 是否为首页列表↓
                IsHomeList: true,
                // 列表标题↓
                ListTitle: '执法事由',
                // 列表数据↓
                ListData: {},
                // 查询参数↑
                ListParams: {
                    ids: '',
                    causeKeyWords: '',
                    lawKeyWords: '',
                    funcUnitType: [],
                    causeType: [],
                    effectLevel: '',
                    lawType: [],
                    startTime: '',
                    endTime: '',
                    pageSize: 10,
                    pageNum: 1
                },
                // 查询记录
                RecordValue: [],
                // 加载特效
                SpinShow: true,
                // 回显数据
                EchoData: {},
                RouterName: 'CauseDetails',
                routerParams: ''
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
          // 有参数为v6用户进入系统
          if (Object.keys(this.$route.params).length > 0) {
            this.routerParams = this.$route.params;
            this.getV6ListData();
          } else {
            // 获取事由类型字典表
            let getCauseTypeData = this.$store.dispatch('GET_CAUSETYPE_DATA', {});
            // 获取事由领域字典表
            let getCauseFieldData = this.$store.dispatch('GET_CAUSEFIELD_DATA', {});
            // 获取其他字典表
            let getDictData = this.$store.dispatch('GET_DICT_DATA', {});
            // 获取聚合数据
            let getLawAggData = this.$store.dispatch('GET_LAWAGG_DATA', {});
            // promise异步请求
            Promise.all([getCauseTypeData, getCauseFieldData, getDictData, getLawAggData]).then(data => {
                this.LoadDict = true;
            });
          }
        },
        destoryed() {

        },
        methods: {
            // 获取v6查询对应数据
            getV6ListData() {
              // 获取事由类型字典表
              let getCauseTypeData = this.$store.dispatch('GET_CAUSETYPE_DATA', {});
              // 获取事由领域字典表
              let getCauseFieldData = this.$store.dispatch('GET_CAUSEFIELD_DATA', {});
              // 获取其他字典表
              let getDictData = this.$store.dispatch('GET_DICT_DATA', {});
              // 获取聚合数据
              let getLawAggData = this.$store.dispatch('GET_LAWAGG_DATA', {});
              // promise异步请求
              Promise.all([getCauseTypeData, getCauseFieldData, getDictData, getLawAggData]).then(data => {
                  // this.LoadDict = true;
              });
              this.SpinShow = true;
              // 回显检索条件
              this.RecordValue = [{
                id: 7,
                key: 'ids',
                value: this.routerParams.key,
                describe: `关键词：${this.routerParams.key}`
              }];
              // 赋值ids，进行查询
              this.ListParams.ids = this.routerParams.causeIds;
              reqCause(this.ListParams).then(res => {
                  if (res.ok) {
                      this.SpinShow = false;
                      if (res.data.list.length == 1) {
                        this.$router.push({ 
                          name: 'CauseDetails',
                          query: { id: res.data.list[0].causeId },
                          params: res.data.list[0]
                        });
                      } else {
                        res.data.list.length = res.data.list.length > 5 ? 5 : res.data.list.length;
                        this.ListData = res.data;
                      }
                  }
              });
            },
            // 接收搜索组件的搜索条件
            emitSearch(data) {
                this.ListParams = { ...this.ListParams, ...data };
                this.getCauseListData(this.EchoData);
            },

            // 接收高级搜索组件的搜索条件
            emitHighSearch(data, extend) {
                this.EchoData = { ...this.EchoData, ...extend };
                this.ListParams = { ...this.ListParams, ...data };
                this.getCauseListData(this.EchoData);
            },

            // 接收导航组件的搜索条件
            emitNav(data, extend) {
                this.EchoData = { ...this.EchoData, ...extend };
                this.ListParams = { ...this.ListParams, ...data };
                this.getCauseListData(this.EchoData);
            },

            emitToDetails() {
                this.$router.push({ name: 'CauseList', params: this.ListParams });
            },

            // 功能 删除搜索记录
            handleClose(data) {
                this.EchoData[data.key] = [];
                this.EchoData = Object.assign({}, this.EchoData);

                if (Array.isArray(data.value)) {
                    this.ListParams[data.key] = [];
                } else {
                    this.ListParams[data.key] = '';
                }

                this.RecordValue.forEach((item, index) => {
                    if (item.id == data.id) {
                        this.RecordValue.splice(index, 1);
                    }
                });

                // let tempParams = {};
                // this.RecordValue.forEach((item, i) => {
                //   tempParams[item.key] = item.value;
                // });
                // this.ListParams = {...this.ListParams, ...tempParams};

                this.getCauseListData(this.EchoData);
            },

            // 请求事由组件的数据列表
            getCauseListData(extend) {
                this.SpinShow = true;
                // 返回拼接好的搜索记录数组
                this.RecordValue = this.buildRecordArr(this.ListParams, extend);
                this.ListParams.ids = this.ListParams.ids ? this.ListParams.ids : '';
                // 获取事由组件数据
                reqCause(this.ListParams).then(res => {
                    if (res.ok) {
                        this.SpinShow = false;
                        res.data.list.length = res.data.list.length > 5 ? 5 : res.data.list.length;
                        this.ListData = res.data;
                    }
                });
            },

            // 功能 组织搜集记录数据结构
            buildRecordArr(postData, extend) {
                // debugger
                // if (!extend) {
                //   return;
                // }
                let arr = [];
                for (let key in postData) {
                    if (key == 'causeKeyWords' && postData[key]) {
                        arr.push({
                            id: 1,
                            key: key,
                            value: postData[key],
                            describe: `事由关键词：${postData[key]}`
                        });
                    }
                    if (key == 'lawKeyWords' && postData[key]) {
                        arr.push({
                            id: 2,
                            key: key,
                            value: postData[key],
                            describe: `法规关键词：${postData[key]}`
                        });
                    }
                    if (key == 'funcUnitType' && postData[key].length > 0) {
                        let desc = [];
                        extend[key].forEach(item => {
                            desc.push(item.unitFuncTypeName);
                        });
                        arr.push({
                            id: 3,
                            key: key,
                            value: postData[key],
                            describe: `事由领域：${desc.join(',')}`
                        });
                    }
                    if (key == 'causeType' && postData[key].length > 0) {
                        let desc = [];
                        extend[key].forEach(item => {
                            desc.push(item.excuteTypeName);
                        });
                        arr.push({
                            id: 4,
                            key: key,
                            value: postData[key],
                            describe: `事由类型：${desc.join(',')}`
                        });
                    }
                    if (key == 'effectLevel' && postData[key]) {
                        let desc = [];
                        extend[key].forEach(item => {
                            desc.push(item.effectLevelName);
                        });
                        arr.push({
                            id: 5,
                            key: key,
                            value: postData[key],
                            describe: `效力级别：${desc.join(',')}`
                        });
                    }
                    if (key == 'lawType' && postData[key].length > 0) {
                        let desc = [];
                        extend[key].forEach(item => {
                            desc.push(item.lawTypeName);
                        });
                        arr.push({
                            id: 6,
                            key: key,
                            value: postData[key],
                            describe: `法规类别：${desc.join(',')}`
                        });
                    }
                }
                return arr;
            }
        }
    }
</script>

<style scoped>
    .content {
        margin: 0 auto;
        width: 1200px;
        min-height: calc(100% - 50px - 112px);
    }

    .home {
      background: #f7f8f8;
    }
</style>